import { Check, Send } from "lucide-react";

export default function PressContact({ form, setForm, onSubmit, submitting, sent }) {
  return (
    <section id="contact" className="max-w-7xl mx-auto px-6 md:px-8 py-16">
      <div className="border border-white/10 bg-[#141414] p-8 md:p-12 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="overline">Brand partnerships</div>
          <h2 className="font-display text-4xl md:text-5xl uppercase mt-3 drip-shadow">
            Let's make
            <br /> a stop happen.
          </h2>
          <p className="text-white/70 mt-5 max-w-md">
            Tell us where you want to plug in — a city, a drop, a feature, a campaign — and we'll
            come back with a tailored route. Most replies inside 48 hours.
          </p>
          <div className="mt-6 font-script text-2xl text-white/80">Worth the stop.</div>
        </div>

        <div className="md:col-span-7">
          {sent ? (
            <div
              className="border border-[#FFC107]/40 bg-[#0A0A0A] p-8 text-center"
              data-testid="press-form-success"
            >
              <div className="w-14 h-14 mx-auto bg-[#FFC107] text-[#0A0A0A] flex items-center justify-center">
                <Check size={26} />
              </div>
              <div className="overline mt-5">Inquiry received</div>
              <h3 className="font-display text-3xl uppercase mt-3">We're on it.</h3>
              <p className="text-white/70 text-sm mt-3">
                Reply lands in your inbox shortly. In the meantime,{" "}
                <a href="https://instagram.com/fuelmeh" className="text-[#FF1493] underline-offset-4 hover:underline">
                  follow @fuelmeh
                </a>
                .
              </p>
            </div>
          ) : (
            <form
              onSubmit={onSubmit}
              className="space-y-3"
              data-testid="press-contact-form"
            >
              <div className="grid grid-cols-2 gap-3">
                <input
                  required
                  placeholder="Your name"
                  className="tac-input"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  data-testid="press-name"
                />
                <input
                  required
                  type="email"
                  placeholder="Email"
                  className="tac-input"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  data-testid="press-email"
                />
              </div>
              <input
                placeholder="Company / brand (optional)"
                className="tac-input"
                value={form.company}
                onChange={(e) => setForm({ ...form, company: e.target.value })}
                data-testid="press-company"
              />
              <select
                className="tac-input bg-[#0A0A0A]"
                value={form.inquiry_type}
                onChange={(e) => setForm({ ...form, inquiry_type: e.target.value })}
                data-testid="press-inquiry-type"
              >
                <option>Brand Partnership</option>
                <option>Product Collab</option>
                <option>Event Sponsorship</option>
                <option>Social Media Feature</option>
                <option>Content Integration</option>
                <option>Press / Media Request</option>
              </select>
              <textarea
                required
                rows={5}
                placeholder="Tell us what you're thinking..."
                className="tac-input"
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                data-testid="press-message"
              />
              <button
                type="submit"
                disabled={submitting}
                className="btn-blaze w-full justify-center"
                data-testid="press-submit"
              >
                <Send size={14} />
                {submitting ? "Sending..." : "Send inquiry"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
